class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.querySelector('.mobile-serachbox #predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) { 
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=9999&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector('.mobile-serachbox .search_suggestion').style.display = 'none';
    // if(window.innerWidth < 992){
    //   document.querySelector('.mobile-serachbox .search_recommended_wrap').style.display = 'none';
    // }
    document.querySelector('.mobile-serachbox .search_recommended').classList.add('search_active');
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('.mobile-serachbox .search_suggestion').style.display = 'block';
    // if(window.innerWidth < 992){
    //   document.querySelector('.mobile-serachbox .search_recommended_wrap').style.display = 'block';
    // }
    document.querySelector('.mobile-serachbox .search_recommended').classList.remove('search_active');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('.mobile-serachbox .search_recommended').style.maxHeight = window.innerHeight - (document.querySelector('.header-row').clientHeight + document.querySelector('.mobile-serachbox').clientHeight) + 'px'
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
    var Swipes = new Swiper('.mobile-serachbox .search_recommended_slider', {
      loop: false,
      slidesPerView: "auto",
      a11y: true,
      navigation: {
        nextEl: ".search_next_arrow",
        prevEl: ".search_prev_arrow",
      },
    });
  });
});
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open_filter','open_sort','open-drawer','open-menu','open-search', 'open-account', 'open_lang', 'open_variant');
    $('.outer_drop_down').slideUp();
    $('.dropdown-wrap').removeClass('active');
    document.querySelector('#collection-grid').classList.remove('open-sort', 'open-filter');
  }
};
/*$(window).on('load',function(e){
  $('.media-video').each(function(e){
    var mediawrap = $(this).attr('id');
    var videoid = $(this).data('id');
    var player = jwplayer(mediawrap);
    player.setup({playlist: 'https://cdn.jwplayer.com/v2/media/'+videoid,controls: false,repeat:true,autostart: true,mute: true});
  });
});*/

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
appHeight();




var body = document.body; 
// var is index =
// transparent-head-top

// window.onload = function(){
  if (document.body.classList.contains('home-index') || document.body.classList.contains('landing_page_body') || document.body.classList.contains('landing_new') 
      || document.body.classList.contains('page-landing_aw24_anelka') || document.body.classList.contains('page-landing_katajanokka') 
      || document.body.classList.contains('page-landing_alassan_diawara') || document.body.classList.contains('page-landing_anderlecht') 
      || document.body.classList.contains('page-landing_aw20') || document.body.classList.contains('page-landing_aw21') 
      || document.body.classList.contains('page-landing_aw22') || document.body.classList.contains('page-landing_aw23') 
      || document.body.classList.contains('page-landing_aw23london') || document.body.classList.contains('page-landing_aw24') 
      || document.body.classList.contains('page-landing_aw24d2') || document.body.classList.contains('page-landing_aw24d3')
     || document.body.classList.contains('page-landing_icons23') || document.body.classList.contains('page-landing_jeanjass')
      || document.body.classList.contains('page-landing_rafael_leao') || document.body.classList.contains('page-landing_samsung')
     || document.body.classList.contains('page-landing_ss20') || document.body.classList.contains('page-landing_ss22')
     || document.body.classList.contains('page-landing_ss22_activewear') || document.body.classList.contains('page-landing_ss22')) {
    


      var doc = document.documentElement; 
      doc = (doc.clientHeight)? doc : body;
    
      if (doc.scrollTop <= 12){
          body.classList.add('transparent-header', 'transparent-head-top')
      } else {
        body.classList.remove('transparent-header', 'transparent-head-top')
      } 
  
   
  
  window.onscroll = function(){
      var doc = document.documentElement; 
      doc = (doc.clientHeight)? doc : body;
      if (doc.scrollTop <= 12){
          body.classList.add('transparent-header', 'transparent-head-top', 'landing_new')
          
      } else {
        body.classList.remove('transparent-header', 'transparent-head-top', 'landing_new')
      }  
  };
  
 // const announcementBar = document.querySelector(".transparent-head-top #shopify-section-announcement-bar")
 // const header = document.querySelector(".transparent-head-top #shopify-section-header")
  
 // header.addEventListener("mouseenter", (e) => {
 //   body.classList.remove('transparent-header')
 // });
 // announcementBar.addEventListener("mouseenter", (e) => {
 //   body.classList.remove('transparent-header')
 // });
  
 // header.addEventListener("mouseleave", (e) => {
 //   body.classList.add('transparent-header')
 // });
 // announcementBar.addEventListener("mouseleave", (e) => {
 //   body.classList.add('transparent-header')
 // });
    }

  


// $().each(function() {

// });


$(document).ready(function() {

        $(document).on('click', '.dot_div', function(){
          $(this).parents('.dot_wrapper').toggleClass('active').siblings().removeClass('active')
        })
      
         $(window).on('scroll', function(){
          var pecent_height = (($(window).height() - $('.header-row').height()) * 35) / 100;
         $('.dot_div').each(function(){
            var this_offset = $(this).offset().top - pecent_height;
             if ($(window).scrollTop() >= this_offset && $(window).scrollTop() <= ($(this).offset().top - $('.header-row').height() - 50)){
                $(this).parents('.dot_wrapper').addClass('dot_active') 
             }
             else{
               $(this).parents('.dot_wrapper').removeClass('dot_active') 
               $(this).parents('.dot_wrapper').removeClass('active') 
             }
         });
        });
      
       $(document).on('click', '.dot_wrapper', function(){
        var this_cls = $(this).attr('data-cls');
        $('.pro_name_dv .'+this_cls).toggleClass('act_pro').siblings().removeClass('act_pro');
      })
      
      $(document).on('click', function(e){
        if (!$(e.target).closest('.dot_wrapper').length) {
          $('.dot_wrapper').removeClass('active');
        }
      })
        $(window).on('scroll',function(){
          if($('.inner_row_section .block_itm').length > 0){
            // console.log($(window).scrollTop() , $('.inner_row_section .block_itm').offset().top - 100 , $(window).scrollTop() , $('.section-footer').offset().top - 750)
            if($(window).scrollTop() > $('.inner_row_section .block_itm').offset().top - 100 ){
              if(!$('.main_sticky_button').hasClass('fixed')){
                  $('.main_sticky_button').hide()
                  $('.main_sticky_button').addClass('fixed');
                  $('.main_sticky_button').fadeIn('slow')
                }
              }
              else {
                $('.main_sticky_button').removeClass('fixed'); 
                $('.main_sticky_button').hide();
              }
          }
        })
        if($(".dot_button_hide_show")){
          $(document).on('click', '.dot_button_hide_show', function(){
            $(this).toggleClass("active");
            $("span.dot_wrapper").toggle();
            // $(this).text(function(i, v){
            //   console.log(v,i)
            //   return v === 'Closed eye icon' ? 'Open eye icon' : 'Closed eye icon'
            // });
          })
        }
        
      // }
      $(document).on("click",".click_arow",function(){
          if($(this).hasClass("active")){
            $(this).removeClass("active");
            $(".country-selector").removeClass("open");
            $(".country-selector").removeClass("weg-openup");
            $(".country-selector").addClass("closed");
            $(".country-selector").attr("aria-expanded",true);
            $(".country-selector ul").hide();
          }else{
            $(this).addClass("active");
            $(".country-selector").addClass("open");
            $(".country-selector").addClass("weg-openup");
            $(".country-selector").removeClass("closed");
            $(".country-selector").attr("aria-expanded",true);
            $(".country-selector ul").show(); 
          }
      })


  
  var path = $(location).attr('hash');
  var main_path = path.split('#')[1]
  
  $('.store_slide .slide_itm').each(function(e) {
    var id = $(this).find('h2').attr("data-id")
    if(main_path == id){
      $(this).find('h2').trigger('click');
    }
  })
  
})


var lastScrollTop = 0;
document.addEventListener("scroll", function(){ 
  if(window.innerWidth < 767){
    if(document.querySelector(".collection_template")){
       var st = window.pageYOffset || document.documentElement.scrollTop;
       if (st > lastScrollTop) {
           document.body.classList.remove("sticky-header");
           document.querySelector(".collection_template .collection_filter_bar").style.top="0";
          console.log("downscroll")
       } else if (st < lastScrollTop) {
           document.body.classList.add("sticky-header");
           document.querySelector(".collection_template .collection_filter_bar").style.top="59px";
           console.log("Upscroll")
       } 
       lastScrollTop = st <= 0 ? 0 : st;                        
    }
  }
}, false);

  


$(document).ready(function(){
  $('.customer-field input').each(function(){
    if($(this).val() != '' ){
        $(this).addClass('filled_input')
    }
});
  if($(".click_arow")){
    $(document).on('click', '.click_arow', function(){
      $('.weglot_switcher').trigger('click');    
    })
  }
  

  
 //  var h3height = 0;
 // $('.pro_name').each(function() {
 //    if(h3height < $(this).outerHeight()){
 //      h3height = $(this).outerHeight();
 //    };
 //  });
 //  $('.pro_name').height(h3height);
  if($("body").hasClass("collection_template")){
    $('.pro_name').matchHeight({property: 'height'});
  }
  // var ht_img = 0;
  // $('.product-images').each(function() {
  //   if(ht_img < $(this).outerHeight()){
  //     ht_img = $(this).outerHeight();
  //   };
  // });
  // $('.product-images').height(ht_img);
  
      $(document).on('click', '.close_search', function(e){
        $('body').removeClass('open-search');
        $('.src_inpt').val('');
      });
    
    
    $(document).on('click', '.pop_up_logged_out', function(){
        $('body').addClass('notify_user')
    });
    $('body').on('click',function(e){
      var container = $(".inner_notification_body");
      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('body').removeClass('notify_user')
      }
    });
    $(document).on('click', '.inner_notification_body .not_close svg', function () {
      $('body').removeClass('notify_user')
    })

  if($(".template-product")){
    if(window.innerWidth < 768){
      function alertSize() {
        var myWidth = 0, myHeight = 0;
        if( typeof( window.innerWidth ) == 'number' ) {
          //Non-IE
          myWidth = window.innerWidth;
          myHeight = window.innerHeight;
        } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
          //IE 6+ in 'standards compliant mode'
          myWidth = document.documentElement.clientWidth;
          myHeight = document.documentElement.clientHeight;
        } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
          //IE 4 compatible
          myWidth = document.body.clientWidth;
          myHeight = document.body.clientHeight;
        }
        return myHeight;
      }
      var browserHeight  = alertSize()+"px";
      var productPageimageSize = $(".inner_info_fixed").height();
      console.log("browserHeight-->",browserHeight)
      var totalHeight = productPageimageSize + 58 + "px";
      $(".NewProductTemplate .media-grid-inner").css({"height": "calc("+browserHeight+" - "+ totalHeight +")"});
      console.log("productPageimageSize-->",productPageimageSize)
    }
  }
})

// document.querySelector('.block-popup-btn .login').addEventListener('click', function() {
//     alert('yes');
//     document.querySelector('.popup-login').style.display = 'block';
// });


var loginButton = document.querySelector('.block-popup-btn .log-in');
if (loginButton) {
    loginButton.addEventListener('click', function() {
        var btn = document.querySelector('.block-popup-btn');
        if (btn) {
            btn.style.display = 'none';
        }
        var popupLogin = document.querySelector('.popup-login');
        if (popupLogin) {
            popupLogin.style.display = 'block';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    function selectLanguageRadioInput() {
      const currentUrl = window.location.href;
      const frenchRadioInputId = "Langauge__3__9";
      const defaultRadioInputId = "Langauge__3__8";

      function triggerChangeEvent(element) {
        const event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });
        element.dispatchEvent(event);
      }

      if (currentUrl.includes("https://fr.arte-antwerp.com")) {
        const frenchRadioInput = document.getElementById(frenchRadioInputId);
        if (frenchRadioInput) {
          frenchRadioInput.checked = true;
          triggerChangeEvent(frenchRadioInput); // Trigger change event after setting checked
        } else {
          console.error("French radio input not found");
        }
      } else {
        const defaultRadioInput = document.getElementById(defaultRadioInputId);
        if (defaultRadioInput) {
          defaultRadioInput.checked = true;
          triggerChangeEvent(defaultRadioInput); // Trigger change event after setting checked
        } else {
          console.error("Default radio input not found");
        }
      }
    }

    selectLanguageRadioInput();
  }, 2000); 
});

// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function() {
//     const chatButton = document.querySelector('.gorgias-chat-key-76gqfx');
//     const footer = document.querySelector('.footer-copyright');
//     let lastScrollTop = 0;
    

//     if (!chatButton || !footer) {
//       console.error('Chat button or footer not found');
//       return;
//     }

//     function adjustChatButtonPosition() {
//       const footerRect = footer.getBoundingClientRect();

//       if (footerRect.top < window.innerHeight) {
//         if (window.innerWidth <= 768) {
//           chatButton.style.setProperty('bottom', `${window.innerHeight - footerRect.top + 5}px`);
//         } else { // Desktop
//           chatButton.style.setProperty('bottom', `${window.innerHeight - footerRect.top + 24}px`);
//         }
//       } else {
//         if (window.innerWidth <= 768) {
//           chatButton.style.removeProperty('bottom');
//         } else { // Desktop
//           chatButton.style.removeProperty('bottom');
//         }
//       }
//     }

//     function handleScroll() {
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       if (scrollTop > lastScrollTop) {
//         document.body.classList.remove('scroll-up');
//         document.body.classList.add('scroll-down');
//       } else {
//         document.body.classList.remove('scroll-down');
//         document.body.classList.add('scroll-up');
//       }
//       lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
//     }

//     window.addEventListener('scroll', adjustChatButtonPosition);
//     window.addEventListener('resize', adjustChatButtonPosition);
//     window.addEventListener('scroll', handleScroll);

//     adjustChatButtonPosition();
//   }, 500);
// });


var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(async () => {
  const chatButton = document.querySelector('.gorgias-chat-key-76gqfx');
  const footer = document.querySelector('.footer-copyright');
  let lastScrollTop = 0;
  

  if (!chatButton || !footer) {
    console.error('Chat button or footer not found');
    return;
  }

  function adjustChatButtonPosition() {
    const footerRect = footer.getBoundingClientRect();

    if (footerRect.top < window.innerHeight) {
      if (window.innerWidth <= 768) {
        chatButton.style.setProperty('bottom', `${window.innerHeight - footerRect.top + 5}px`);
      } else { // Desktop
        chatButton.style.setProperty('bottom', `${window.innerHeight - footerRect.top + 24}px`);
      }
    } else {
      if (window.innerWidth <= 768) {
        chatButton.style.removeProperty('bottom');
      } else { // Desktop
        chatButton.style.removeProperty('bottom');
      }
    }
  }

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    } else {
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  window.addEventListener('scroll', adjustChatButtonPosition);
  window.addEventListener('resize', adjustChatButtonPosition);
  window.addEventListener('scroll', handleScroll);

  adjustChatButtonPosition();
})